const extraProcessSaveProductInput = (input) => {
  return input.map(product => ({
    ...product,
    customOutput4: product.customOutput4.replace(/;/g, '%')
  }));
};

export default extraProcessSaveProductInput;
